import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const showSuccessMessage = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
  });
};

export const showErrorMessage = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 3000,
  });
};
